import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { messages } from '@/i18n';
import { AuthScreenLayout } from './AuthScreenLayout';

export function SignedOut() {
  return (
    <AuthScreenLayout title={messages.signedOut.title} description={messages.signedOut.body}>
      <Button asChild className="w-full">
        <Link to="/sign-in">{messages.common.backToSignIn}</Link>
      </Button>
    </AuthScreenLayout>
  );
}
